import * as React from 'react';
export var useMountedRef = function useMountedRef() {
  var mounted = React.useRef(true);
  var runIfMounted = function runIfMounted(cb) {
    if (mounted.current) {
      cb();
    }
  };
  React.useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  });
  return [mounted, runIfMounted];
};
export var useIfMountedCallback = function useIfMountedCallback() {
  return useMountedRef()[1];
};